export default __webpack_public_path__ + "static/media/My_Family_Health_Check_Up.abf6ccfc.svg";